<template>
  <div class="container">
    Processing Login:
    <sdx-loading-spinner id="spinner-login" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="loginText">{{ this.loginProgressText }}!</div>
    <div id="bar01" class="loader-bar">
      <div class="loader-bar--progress">
        <div class="indicator" style="width: 0%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import loginService, {EVENT_LOGIN_CHANGED} from '@/modules/login/service';
import userService from "@/services/user.service";
import {logger} from "@/services/logger.service";
import LoaderBar from "@swisscom/sdx/dist/es6/loader/LoaderBar";
import loadingSpinnerService from "@/services/loading-spinner.service";


export default {
  data() {
    return {
      loginProgressText: "Login ...",
    }
  },
  async mounted() {
    loadingSpinnerService.show("loginId");
    logger.info("Login 0/5: Start")
    let provider = this.$route.params.provider;
    if (provider === undefined)
      provider = "dev"
    logger.info("Login with provider: " + provider);
    let loaderBar = new LoaderBar(document.querySelector("#bar01"));

    //New Login -> clear all session data (probably from another user)
    this.loginProgressText = "Login " + provider + ": Clear old user data"
    logger.info("Login 1/: Clear old user data")
    loaderBar.progress = 0.2;
    userService.clearUserData();

    this.loginProgressText = "Login " + provider + ": Processing login provider"
    logger.info("Login 2/5: Processing login provider")
    loaderBar.progress = 0.4;
    try {
      let result = await loginService.providerLogin(
          provider,
          this.$route.query.code,
          this.$route.query.state);
      logger.info("Login successful. result=" + result);
    } catch (error) {
      logger.error("Login Error: " + error);
    }

    this.loginProgressText = "Login " + provider + ": Update user information"
    logger.info("Login 3/5: Update user information")
    loaderBar.progress = 0.6;
    await userService.updateUserInformation();

    this.loginProgressText = "Login " + provider + ": Change user"
    logger.info("Login 4/5: Event: Change user")
    loaderBar.progress = 0.8;
    logger.debug("EVENT: " + EVENT_LOGIN_CHANGED);
    this.$emit(EVENT_LOGIN_CHANGED, {});

    this.loginProgressText = "Login " + provider + ": Redirect"
    logger.info("Login 5/5: Redirect")
    loaderBar.progress = 1;

    let returnUrl = localStorage.getItem("returnUrl");
    logger.info("Get returnUrl: " + returnUrl)
    if (returnUrl == null || returnUrl == undefined || returnUrl == "undefined" || returnUrl == "" || returnUrl.startsWith("/login")) {
      logger.info("No returnUrl found in localStorage, using default /");
      returnUrl = "/";
    }
    logger.info("Go to returnUrl: " + returnUrl)
    localStorage.removeItem("returnUrl");
    this.$router.push(returnUrl);
  }, unmounted() {
    logger.debug("Unmounted");
  },
  methods: {

  }
};
</script>